/*
 * Project: BKN_FRONT
 * Copyright (c) 2024 Nttdata
 */
import React from "react";
import { Box, Breadcrumbs, Paper, Grid, Stack, Link} from "@mui/material";
import KeyboardArrowRight from "@mui/icons-material/KeyboardArrowRightRounded";
import "./dadesPeticio.css";
import CampTextForm from "../../../components/formCamps/CampTextForm";
import { NavBar } from "../../../components/PantallesBKI/Header/Header";
import Tipografia from "../../../components/Requeriment/Tipografia";
import TaulaDocumentacio from "../../../components/Requeriment/taula/Taula";
import { useNavigate } from "react-router-dom";
import UploadSamplesFile from "../../../components/Requeriment/uploadFile/UploadSamplesFile";

export default function DadesPeticio() {

  const navigate = useNavigate();

  const dadesRequerimentString = localStorage.getItem("dadesRequeriment");
  const dadesRequeriment = JSON.parse(dadesRequerimentString);
  const estatRequeriment = dadesRequeriment ? dadesRequeriment.estat === "En termini" : false;
  const documentRequeriment = dadesRequeriment && dadesRequeriment.document !== null  && dadesRequeriment.document.length !== 0;
  
  const formatData = dadesRequeriment ? new Date(dadesRequeriment.dataPeticio) : null;

  const breadcrumbs = (
    <Stack paddingTop={2} direction="row">
      <Link
        paddingRight={1}
        underline="hover"
        key="1"
        sx={{
          cursor: "pointer",
          paddingRight: 0,
        }}
        color="inherit"
        onClick={() => {
          navigate("/requeriment");
        }}
        className="link-breadcrumbs"
      >
        Cerca requeriment
      </Link>
      <KeyboardArrowRight />
      <Tipografia
        paddingLeft={1}
        key={2}
        sx={{
          color: "#900000",
        }}
        titol="Petició d'informació"
      />
    </Stack>
  );

  React.useEffect(() => {
    document.title = `Petició d'informació- Requeriment`;
  }, []);

  return (
    <div className="dadesPeticio-div-container">
    <NavBar link="/requeriment" />
   
    <Box className="afegirplantilla-padding-bottom-box">
        <Breadcrumbs aria-label="breadcrumb">{breadcrumbs}</Breadcrumbs>
        <Tipografia
        paddingLeft={1}
        key={2}
        variant={"h4"}
        style={{ color: "#900000", marginBottom: "50px", marginTop: "20px" }}
        fontWeight={600}
        titol="Petició d'informació"
      />
      </Box>
  
      {dadesRequeriment ? (
     <>
      
      <Paper elevation={1} className="paper-padding">
        <Box marginBottom={1}>
          <Tipografia
            titol={"Dades de la petició"}
            variant={"h6"}
            component={"div"}
            style={{ color: "#900000" }}
            fontWeight={600}
          />
        </Box>
      </Paper>

      <Paper elevation={3} className="paper-padding">
        <Grid container spacing={2} className="pdn25">
          <Grid item container spacing={2}>
            <Grid item xs={12} md={3} justifyContent="flex-start">
              <CampTextForm
                value={dadesRequeriment.codi}
                label="Codi"
                nom="Codi"
              />
            </Grid>

            <Grid item xs={12} md={3} justifyContent="flex-start">
              <CampTextForm
                value={dadesRequeriment.numActuacio}
                label="Número d'actuació"
                nom="numActuacio"
              />
            </Grid>

            <Grid item xs={12} md={3} justifyContent="flex-start">
              <CampTextForm
                value={dadesRequeriment.estat}
                label="Estat"
                nom="estat"
              />
            </Grid>

            <Grid item xs={12} md={3} justifyContent="flex-start">
              <CampTextForm
                value={formatData.toLocaleDateString()}
                label="Data petició"
                nom="DataPeticio"
              />
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <div className="linea-separadora"></div>

      <Paper elevation={1} className="paper-padding">
        <Box marginBottom={0.5}>
          <Tipografia
            titol={"Dades de l'indret"}
            variant={"h6"}
            component={"div"}
            style={{ color: "#900000" }}
            fontWeight={600}
          />
        </Box>
      </Paper>

      <Paper elevation={1} className="paper-padding">
        <Grid container spacing={2} className="pdn25">
          <Grid item container spacing={2} >
            <Grid item xs={12} md={4.5} justifyContent="flex-start" >
              <CampTextForm
                value={dadesRequeriment.nomIndret}
                label="Nom indret"
                nom="nomIndret"
              />
            </Grid>

            <Grid item xs={12} md={4.5} justifyContent="flex-start">
              <CampTextForm
                value={dadesRequeriment.raoSocial}
                label="Raó social"
                nom="raoSocial"
              />
            </Grid>

            <Grid item xs={12} md={3} justifyContent="flex-start">
              <CampTextForm
                value={dadesRequeriment.nif}
                label="DNI / NIF / NIE"
                nom="estat"
              />
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <div className="linea-separadora"></div>

            <Paper elevation={1} className="paper-padding">
              <Box marginBottom={0.5}>
                <Tipografia
                  titol={"Documentació"}
                  variant={"h6"}
                  component={"div"}
                  style={{ color: "#900000" }}
                  fontWeight={600}
                />
              </Box>
            </Paper>
    
            {documentRequeriment && ( 
          
            <Paper elevation={1} className="paper-padding">
              <Grid container spacing={2} className="w100">
                <Grid item container spacing={2} sx={{ margin: "0 auto" }}>
                  <TaulaDocumentacio rowData={dadesRequeriment.document} />
                </Grid>
              </Grid>
            </Paper>
          )}
        
            {estatRequeriment && (

            <Paper elevation={1} className="paper-padding">
              <UploadSamplesFile />
            </Paper>
            )}
        
     </>
    ) : (
     
          window.location ="/requeriment"
    
    )}
  </div>
);
}
